export default __webpack_public_path__ + "static/media/meeting_room.1d04f1e1.svg";